// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-d5370c02] ul {\n  z-index: 10000;\n}\n[data-v-d5370c02] .dropdown-item {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  border-bottom: solid 1px #e0e2e4;\n}\n[data-v-d5370c02] .dropdown-item svg {\n    padding-left: 5px;\n    margin-left: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
